import { Injectable } from '@angular/core';
import { AppHttpClient } from '@app/shared/services/http.service';
import { Observable, ReplaySubject } from 'rxjs';
import {
  IAllInvitation,
  IInvitation,
  ISendInvitation,
} from '@app/modules/invitations/interface/invitation';

@Injectable()
export class InvitationsService {
  /**
   * @param http
   */
  constructor(private readonly http: AppHttpClient) {}

  public getAllInvitations(): Observable<IAllInvitation[]> {
    const result = new ReplaySubject<IAllInvitation[]>();

    this.http.get('invitations').subscribe(
      (response: IAllInvitation[]) => result.next(response),
      ({ error }) => result.error(error)
    );

    return result.asObservable();
  }

  public sendInvitation(item: ISendInvitation): Observable<IAllInvitation> {
    const result = new ReplaySubject<IAllInvitation>();

    this.http.post('invitations/inviter/send', item).subscribe(
      (response: IAllInvitation) => result.next(response),
      ({ error }) => result.error(error)
    );

    return result.asObservable();
  }

  public acceptInvitation(invitationId: number): Observable<boolean> {
    const result = new ReplaySubject<boolean>();

    this.http
      .post(`invitations/recepient/accept/${invitationId}`, {})
      .subscribe(
        () => result.next(true),
        ({ error }) => result.error(error)
      );

    return result.asObservable();
  }

  public declineInvitation(invitationId: number): Observable<boolean> {
    const result = new ReplaySubject<boolean>();

    this.http
      .post(`invitations/recepient/decline/${invitationId}`, {})
      .subscribe(
        () => result.next(true),
        ({ error }) => result.error(error)
      );

    return result.asObservable();
  }

  public cancelInvitation(invitationId: number): Observable<boolean> {
    const result = new ReplaySubject<boolean>();

    this.http.post(`invitations/inviter/cancel/${invitationId}`, {}).subscribe(
      () => result.next(true),
      ({ error }) => result.error(error)
    );

    return result.asObservable();
  }
}
